<template>
  <v-app>
    <v-layout>
      <v-app-bar>
        <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer" />
        <v-toolbar-title>ADMINISTRACIÓN</v-toolbar-title>

        <template v-if="$vuetify.display.mdAndUp">
          <v-btn icon="mdi-magnify" variant="text" />
          <v-btn icon="mdi-filter" variant="text" />
        </template>

        <v-menu location="bottom end">
          <template #activator="{ props }">
            <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props" />
          </template>
          <v-list>
            <!-- <v-list-item @click="goToProfile">
              <v-list-item-title>Perfil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="goToSettings">
              <v-list-item-title>Configuración</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider> -->
            <v-list-item @click="closeOtherTabs">
              <v-list-item-title>Cerrar otras pestañas</v-list-item-title>
            </v-list-item>
            <v-list-item @click="closeAllTabs">
              <v-list-item-title>Cerrar todas las pestañas</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="logout">
              <v-list-item-title class="text-red">Cerrar sesión</v-list-item-title>
            </v-list-item>
          </v-list>
 
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer
        app
        v-model="drawer"
        clipped
        :location="$vuetify.display.mobile ? 'bottom' : undefined"
        permanent
      >
        <v-list>
          <v-list-item
            prepend-avatar="https://this-person-does-not-exist.com/img/avatar-gencc9c6241e70d5610a787db8f337b459e.jpg"
            subtitle="jennifer@google.com"
            title="Jennifer Leider"
          >
            <template v-slot:append>
              <v-btn icon="mdi-menu-down" size="small" variant="text" />
            </template>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-list density="compact" nav>
          <template v-for="(item, index) in menu" :key="index">
            <v-list-group
              v-if="item.children"
              v-model="openGroups[index]"
              @update:model-value="(val: any) => toggleGroup(index)"
              :prepend-icon="item.icon"
            >
              <template #activator="{ props }">
                <v-list-item v-bind="props" :title="item.title" />
              </template>

              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                @click="openTabFromMenu(child)"
                :title="child.title"
                class="pl-6"
              />
            </v-list-group>

            <v-list-item
              v-else
              @click="openTabFromMenu(item)"
              :title="item.title"
              :prepend-icon="item.icon"
            />
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-main>

        <!-- <Breadcrumbs /> -->
        <!-- Sistema de pestañas -->
        <v-tabs
          v-model="activeTabIndex"
          bg-color="surface"
          show-arrows
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          density="default"
          slider-color="primary"
          
        >
          <v-tab
            v-for="tab in tabs"
            :key="tab.id"
            :value="tab.id"
            @click="switchTab(tab.id)"
            variant="elevated" 
          >
            <v-icon v-if="tab.icon" start :icon="tab.icon" size="small" />
            {{ tab.title }}
            <v-btn
              v-if="tab.closable"
              icon="mdi-close"
              size="x-small"
              variant="text"
              class="ml-2"
              @click.stop="closeTab(tab.id)"
            />
          </v-tab>
        </v-tabs>
        
        <router-view v-slot="{ Component }">
          <keep-alive :include="cachedViews">
            <component :is="Component" />
          </keep-alive>
        </router-view>

        <v-snackbar
          v-model="snackbar.show" 
          :color="snackbar.color"
          location="bottom center"
        >
          {{ snackbar.text }}
          <template v-slot:actions>
            <v-btn icon="mdi-close" @click="snackbar.show = false" />
          </template>
        </v-snackbar>
      </v-main>
    </v-layout>
  </v-app>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import { menu as menuData } from '@/data/menu'

const drawer = ref(true)
const menu = menuData
const openGroups = ref<Record<number, boolean>>({})
const store = useStore()
const router = useRouter()
const route = useRoute()

const snackbar = computed(() => store.state.Ui.snackbar)
const estado = computed(() => store.state.Ui.status)
const tabs = computed(() => store.getters['tabs/tabs'])
const activeTab = computed(() => store.getters['tabs/activeTab'])
const cachedViews = computed(() => store.getters['tabs/cachedViews'])

const activeTabIndex = computed({
  get: () => activeTab.value,
  set: (value) => store.dispatch('tabs/setActiveTab', value)
})

// Restaurar tabs al montar el componente
onMounted(() => {
  // Los tabs ya se cargan desde localStorage en el state inicial
  // Solo necesitamos navegar a la ruta activa si es diferente
  const activeRoute = store.getters['tabs/activeTabRoute']
  
  if (route.path !== activeRoute && activeRoute !== '/login') {
    router.push(activeRoute)
  }
})

function generateTabId(route: string): string {
  return route.replace(/\//g, '-').substring(1) || 'dashboard'
}

function findMenuItemByRoute(path: string): any {
  for (const item of menu) {
    if (item.to === path) {
      return item
    }
    if (item.children) {
      const child = item.children.find((c: any) => c.to === path)
      if (child) return child
    }
  }
  return null
}

function openTabFromMenu(menuItem: any) {
  const tabId = generateTabId(menuItem.to)
  const tab = {
    id: tabId,
    title: menuItem.title,
    route: menuItem.to,
    icon: menuItem.icon,
    closable: menuItem.to !== '/dashboard',
    componentName: menuItem.componentName
  }
  
  store.dispatch('tabs/openTab', tab)
  router.push(menuItem.to)
}

function switchTab(tabId: string) {
  const tab = tabs.value.find((t: any) => t.id === tabId)
  if (tab) {
    store.dispatch('tabs/setActiveTab', tabId)
    router.push(tab.route)
  }
}

function closeTab(tabId: string) {
  const currentTabs = tabs.value
  const tabToClose = currentTabs.find((t: any) => t.id === tabId)
  
  if (!tabToClose || !tabToClose.closable) return
  
  store.dispatch('tabs/closeTab', tabId)
  
  const newActiveTab = store.getters['tabs/activeTabRoute']
  if (route.path !== newActiveTab) {
    router.push(newActiveTab)
  }
}

function toggleGroup(index: number) {
  for (const key in openGroups.value) {
    openGroups.value[key] = false
  }
  openGroups.value[index] = true
}

watch(() => route.path, (newPath) => {
  // Ignorar login
  if (newPath === '/login') return
  
  const tabId = generateTabId(newPath)
  const existingTab = tabs.value.find((t: any) => t.id === tabId)
  
  if (!existingTab) {
    const menuItem = findMenuItemByRoute(newPath)
    
    const tab = {
      id: tabId,
      title: menuItem?.title || 'Página',
      route: newPath,
      icon: menuItem?.icon,
      closable: newPath !== '/dashboard',
      componentName: menuItem?.componentName
    }
    
    store.dispatch('tabs/openTab', tab)
  } else if (existingTab) {
    store.dispatch('tabs/setActiveTab', tabId)
  }
})

watch(estado, () => {
  if (estado.value.codeStatus === 401) {
    logout()
  }
})

function goToProfile() {
  console.log('GO TO PERFIL')
}

function goToSettings() {
  console.log('GO TO CONFIGURATION')
}

function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('tabs-state') // Limpiar tabs guardados
  store.dispatch('tabs/clearTabs')
  router.push('/login')
}

function closeOtherTabs() {
  const currentTabs = [...tabs.value]
  const activeTabId = activeTab.value
  
  currentTabs.forEach((tab: any) => {
    if (tab.id !== activeTabId && tab.closable) {
      store.dispatch('tabs/closeTab', tab.id)
    }
  })
}

function closeAllTabs() {
  const currentTabs = [...tabs.value]
  
  currentTabs.forEach((tab: any) => {
    if (tab.closable) {
      store.dispatch('tabs/closeTab', tab.id)
    }
  })
  
  router.push('/dashboard')
}
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
}
.bordered-tabs {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 8px;
}
</style>